import "bootstrap-icons/font/bootstrap-icons.css";
import { useState } from "react";
import baseUrl from "../../utils/baseUrl"
import "./user.css";
import { Image, Segmented, Table, Tag, Typography } from "antd";

import { useEffect } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";

import { loadAllStaff } from "../../redux/rtk/features/user/userSlice";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import ViewBtn from "../Buttons/ViewBtn";
import { CsvLinkBtn } from "../UI/CsvLinkBtn";
import AttendBtn from "../Buttons/AttendBtn";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";

function CustomTable({ list }) {
	const dispatch = useDispatch();
	const [status, setStatus] = useState("true");
	const [columnsToShow, setColumnsToShow] = useState([]);

	const { loading } = useSelector((state) => state.users);

	const columns = [
		{
			id: 1,
			title: "ID",
			dataIndex: "id",
			key: "id",
		},
		{
			id: 2,
			title: "Image",
			dataIndex: "image",
			key: "image",
			render: (image) =>
				image ? (
					<Image
					src={`${baseUrl}/files/${image}`}
						width={50}
						height={50}
						style={{ objectFit: "cover", borderRadius: "40%" }}
						preview={{
							mask: <span style={{ fontSize: 13 }}>View Image</span>,
						}}
					/>
				) : (
					<span>N/A</span>
				),
		},
		{
			id: 3,
			title: "Name",
			key: "fullName",
			render: ({ firstName, lastName }) => (
				<Typography.Text strong>{
					(firstName + " " + lastName).toUpperCase()
				}</Typography.Text>
			),
		},
		{
			id: 4,
			title: "Usr Name",
			dataIndex: "userName",
			key: "userName",
		},
		{
			id: 5,
			title: "Role",
			dataIndex: "role",
			key: "role",
			render: (role) => (
				<Tag color="blue">{role.name}</Tag>
			),
		},
		{
	id: 6,
	title: "Occupation",
	dataIndex: "employmentStatuses", 
	key: "employmentStatuses",
	render: (_, record) => {
		if (record.roleId === 1) return <Tag color="red">Admin</Tag>;

		const statuses = record.employmentStatuses;

		if (statuses && statuses.length > 0) {
			return statuses.map((status) => (
				<Tag key={status.id} color="green">
					{status.name}
				</Tag>
			));
		}

		return <Tag color="pink">Customer</Tag>;
	},
},

		// {
		// 	id: 8,
		// 	title: "Department",
		// 	dataIndex: "department",
		// 	key: "department",
		// 	render: (record) => (record?.name ? record?.name : "N/A"),
		// },

		// {
		// 	id: 9,
		// 	title: "Shift",
		// 	dataIndex: "shift",
		// 	key: "shift",
		// 	render: (record) => (record?.name ? record?.name : "N/A"),
		// },

		{
			id: 7,
			title: "Action",
			dataIndex: "id",
			key: "action",
			render: (id) => (
				<div className="flex justify-start gap-2">
					<UserPrivateComponent permission={"readSingle-user"}>
						<ViewBtn path={`/admin/hr/staffs/${id}/`} />
					</UserPrivateComponent>
					{/* <UserPrivateComponent permission={"readSingle-attendance"}>
						<AttendBtn path={`/admin/attendance/user/${id}`} />
					</UserPrivateComponent> */}
				</div>
			),
		},
	];

	//make a onChange function
	const onChange = (value) => {
		setStatus(value);
		dispatch(loadAllStaff({ status: value }));
	};

	useEffect(() => {
		setColumnsToShow(columns);
	}, []);

	const columnsToShowHandler = (val) => {
		setColumnsToShow(val);
	};

	const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.id }));

	return (
		<div className="ant-card p-4 rounded mt-5 shadow-md bg-white">
			<div className="flex my-2 justify-between items-center">
				<div className="w-50">
					<h4 className="text-2xl mb-2 font-semibold">All Users List</h4>
				</div>
				{list && (
					<div className="flex justify-end mr-4 gap-4">
						<div className="mt-0.5">
							<CsvLinkBtn>
								<CSVLink
									data={list}
									className="btn btn-dark btn-sm"
									style={{ marginTop: "5px" }}
									filename="staffs"
								>
									Download CSV
								</CSVLink>
							</CsvLinkBtn>
						</div>
						{/* <div>
							<Segmented
								className="text-center rounded text-red-500"
								size="middle"
								options={[
									{
										label: (
											<span>
												<i className="bi bi-person-lines-fill"></i> Active
											</span>
										),
										value: "true",
									},
									{
										label: (
											<span>
												<i className="bi bi-person-dash-fill"></i> Inactive
											</span>
										),
										value: "false",
									},
								]}
								value={status}
								onChange={onChange}
							/>
						</div> */}
					</div>
				)}
			</div>
			{list && (
				<div style={{ marginBottom: "30px" }}>
					<ColVisibilityDropdown
						options={columns}
						columns={columns}
						columnsToShowHandler={columnsToShowHandler}
					/>
				</div>
			)}
			<Table
				scroll={{ x: true }}
				loading={loading}
				pagination={{ defaultPageSize: 10 }}
				columns={columnsToShow}
				dataSource={list ? addKeys(list.filter((user) => user.userName.toLowerCase() !== "admin")) : []}

			/>
		</div>
	);
}

const GetAllCust = (props) => {
	const dispatch = useDispatch();
	const list = useSelector((state) => state.users.list);

	useEffect(() => {
		dispatch(loadAllStaff({ status: "true" }));
	}, []);

	// useEffect(() => {
	//   deleteHandler(list, deletedId);
	// }, [deletedId, list]);

	return (
		<UserPrivateComponent permission={"readAll-user"}>
			<div className="card card-custom">
				<div className="card-body">
					<CustomTable list={list} />
				</div>
			</div>
		</UserPrivateComponent>
	);
};

export default GetAllCust;
